import * as Sentry from '@sentry/react';

import { ProductType } from '@generated/gql/graphql';

import { CategorizedProducts, CategorizedQuotes, ProductKeys } from './types';

const getProductIds = (quotes: CategorizedQuotes, product: ProductKeys) => {
  const { available, expired } = quotes;

  if (expired.length === 0) {
    return {
      deselectIds: [],
      selectIds: [],
    };
  }

  return expired.reduce(
    (ids, quote) => {
      const {
        id,
        product: { id: productId },
      } = quote;

      ids.deselectIds.push(id);

      if (available.length === 0) {
        return ids;
      }

      const selectId = available.find(
        ({ product: { id: selectProductId } }) => selectProductId === productId
      )?.id;

      if (selectId) {
        ids.selectIds.push(selectId);
      } else {
        Sentry.captureMessage(
          `useOutdatedBundleModal: available quote is missing for product type: ${product}`
        );
      }

      return ids;
    },
    {
      deselectIds: [] as string[],
      selectIds: [] as string[],
    }
  );
};

const prepareProductIds = (products: CategorizedProducts) => {
  const {
    [ProductType.Broadband]: broadband,
    [ProductType.Mobile]: mobile,
    [ProductType.Insurance]: insurance,
  } = products;

  const broadbandIds = getProductIds(broadband, ProductType.Broadband);
  const mobileIds = getProductIds(mobile, ProductType.Mobile);
  const insuranceIds = getProductIds(insurance, ProductType.Insurance);

  const selectIds = [
    ...broadbandIds.selectIds,
    ...mobileIds.selectIds,
    ...insuranceIds.selectIds,
  ];

  const deselectIds = [
    ...broadbandIds.deselectIds,
    ...mobileIds.deselectIds,
    ...insuranceIds.deselectIds,
  ];

  return {
    selectIds,
    deselectIds,
  };
};

export { prepareProductIds, getProductIds };
